import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import * as React from 'react';

export function SvgEye() {
  return <EyeOpenIcon label="" testId="ads-refreshed-icon" />;
}
